// Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
/**********
 ** Component: IconFolder
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconFolder = props => {
	return (
		<Label htmlFor="folder-input">
			<Figure xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 56 57">
				<path
					fill="#7c838a"
					fillRule="evenodd"
					d="M38.5 24.18h-16a3.92 3.92 0 0 0-4 3.84v9.12a1.5 1.5 0 0 1-3 0v-16.8a2 2 0 0 1 2-1.92h2a3 3 0 0 1 2.1.84l.09.08a7.1 7.1 0 0 0 4.93 2h7.88a2 2 0 0 1 2 1.92h2a3.92 3.92 0 0 0-4-3.84h-7.88A5.08 5.08 0 0 1 23.1 18l-.1-.1a5.08 5.08 0 0 0-3.52-1.4h-2a3.92 3.92 0 0 0-4 3.84v16.8A3.43 3.43 0 0 0 17 40.5h21.5a3.92 3.92 0 0 0 4-3.84V28a3.92 3.92 0 0 0-4-3.84"
				/>
			</Figure>
			<FolderInput name="folder-input" id="folder-input" type="file" onChange={props.onChange} />
		</Label>
	);
};

const Label = styled.label`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: ${rem('56px')};
	height: ${rem('56px')};
	padding: 0;
	border: 0;
`;

const FolderInput = styled.input`
	display: none;
	visibility: hidden;
	width: 1px;
	height: 1px;
	position: relative;
`;

const Figure = styled.svg`
	display: flex;
	flex-direction: row;
	width: ${rem('56px')};
	height: ${rem('56px')};
`;

export default IconFolder;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-folder.jsx